module.exports = __webpack_public_path__ + "static/media/_DSC0685.52856794.jpg";